import React, { useRef } from 'react';
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { InputText } from 'primereact/inputtext'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../reducers'
import { useDispatch } from 'react-redux'
import useEffectOnce from '../hooks/useEffectOnce';
import { DeleteAssistant, fetchAssistantDrop, fetchData, fetchDoctorDrop } from '../reduxactions/suprivisoractions/SupLinkAssitantsActions';
import { SUPRIVISOR_API } from '../ApiNames'
import { LoginService } from '../services/LoginService'
import { Dialog } from 'primereact/dialog'
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';

export const SuprivisorLinkAssistants = () => {
  const uid = window.sessionStorage.getItem('uid');
  const usertype = window.sessionStorage.getItem('usertype');

  const [globalFilter, setGlobalFilter] = useState('');

  const data = useSelector((state: RootState) => state.slinkass.data);
  const datasss = useSelector((state: RootState) => state.slinkass.datass);
  const getdata = useSelector((state: RootState) => state.slinkass.datasss);


  const dispatch = useDispatch();

  //To get data
  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchDoctorDrop(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  //To get data
  const fetchDataAsync1 = async () => {
    try {
      await dispatch(fetchAssistantDrop(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchDataAsync2 = async () => {
    try {
      await dispatch(fetchData(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffectOnce(() => {
    fetchDataAsync();
    fetchDataAsync1();
    fetchDataAsync2();
  }, [dispatch]);
  const [AssistantID, setAssistantId] = useState('')
  const [DoctorID, setDoctorId] = useState('');
  const [addDilog, setaddDilog] = useState(false);
  const [ID, setID] = useState('');
  const toast = useRef<Toast>(null);

  const addDataAsync = async () => {
    try {
      const payload = { doctor: DoctorID, assistant: AssistantID, uid: uid, q: 2 };
      const apiname = SUPRIVISOR_API.slinkass;
      const response = await LoginService.getData(apiname, payload);
      if (response === "Successfully Added") {
        if (toast.current) {
          toast.current.show({ severity: 'success', detail: response });
        }
      } else {
        if (toast.current) {
          toast.current.show({ severity: 'info', detail: response });
        }
      }
      fetchDataAsync2();
      setaddDilog(false);
      setDoctorId('');
      setAssistantId('');
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const close = () => {
    setaddDilog(false);
  };
  const removedata = useSelector((state: RootState) => state.sasslist.remove);
  // const toast4 = useRef(removedata);
  const [delData, setDeleteData] = useState({
    ID: '',
  });
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);

  const Delete = (rowData: any) => {

    setDeleteData({
      ID: rowData.ID,
    });
    setDeleteConfirmation(true);
  };

  const toast2 = useRef<Toast>(null);

  const confirmDelete = async () => {
    const { ID } = delData;
    try {
      const data = await dispatch(DeleteAssistant(ID) as any);
      if (toast2.current) {
        toast2.current.show({ severity: 'error', detail: data, summary: 'Deleted Successfully' });
      }
      setDeleteConfirmation(false);
      fetchDataAsync2();
    } catch (error) {
      console.error('Error deleting data:', error);
    }
  };
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/sup-link.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };

  return (
    <div style={{ marginLeft: '220px' }}>
      <div className="content-wrapper">
        <section className="content-header">
          <div className="container-fluid">
            <div className="grid mb-2">
              <div className="col-6">
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="card-header p-2" style={{ marginTop: '50px' }}>
                <h2>Link Assistants List</h2>
              </div>
              <div className="col-16" style={{ textAlign: "right" }}>
                <a
                  title="help"
                  onClick={(e) => openWindow(e, IUrl)}
                  style={{

                    color: "blue",
                    fontSize: 15, cursor: "pointer"
                  }}
                >Help for this Page &nbsp;
                  <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                </a>
              </div>
              <br></br>
              <div className="card flex flex-wrap justify-content-end">
                <Button label="LinkAssistants" icon='pi-pi-plus' severity="info" onClick={() => setaddDilog(true)} style={{ marginRight: '50px' }} />

              </div>
              <div className="box box-primary">
                <div className="card">
                  <p className="m-0">
                    <div>
                      <div className="card flex flex-wrap justify-content">
                        <span className="p-input-icon-left">
                          <i className="pi pi-search" style={{ paddingLeft: '5px' }} />
                          <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" style={{ paddingLeft: '25px' }} />
                        </span>

                      </div>
                      <DataTable value={getdata} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                        globalFilterFields={['FirstName', 'dfname', 'CaseStatus', 'Status']}>
                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                        <Column field="FirstName" sortable header="Doctor Name"></Column>
                        <Column field="dfname" sortable header="Assistant Name"></Column>
                        <Column header="Option" body={(rowData) => (

                          <div className="options-buttons">
                            <Button icon="pi pi-trash" rounded outlined tooltip="Delete" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'red', width: '2rem', height: '2rem' }} onClick={() => Delete(rowData)} />
                          </div>
                        )}></Column>
                      </DataTable>

                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Dialog header="Link Assistants" visible={addDilog} style={{ width: '35vw', height: 'auto' }} onHide={() => setaddDilog(false)} >
        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label"> Doctor:</label>
          </div>
          <div className="col-6" >
            <Dropdown
              id="country"
              value={DoctorID}
              onChange={(e: DropdownChangeEvent) => setDoctorId(e.value)}
              options={data}
              optionLabel="FirstName"
              optionValue="DoctorID"
              placeholder="Select a Doctor"
              className="custom-dropdown-placeholder"
              style={{ width: '18vw', marginLeft: '10px' }}
            />
          </div>
        </div>
        <div className="grid pt-3">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label"> Assistants:</label>
          </div>
          <div className="col-6" >
            <Dropdown
              id="speciality"
              value={AssistantID}
              onChange={(e: DropdownChangeEvent) => setAssistantId(e.value)}
              options={datasss}
              optionLabel="FirstName"
              optionValue="AssistantID"
              placeholder="Select a Assistants"
              className="custom-dropdown-placeholder"
              style={{ width: '18vw', marginLeft: '10px' }}
            />
          </div>
        </div>
        <Button label="Close" onClick={close} severity="secondary" />
        <Button label="Add" style={{ float: 'right' }} onClick={addDataAsync} />
      </Dialog >
      < Dialog header="Confirm Delete" style={{ width: '30vw' }} visible={deleteConfirmation} onHide={() => setDeleteConfirmation(false)}>
        <div>Are you really want to Remove...?</div>
        <br></br>
        <Button label="Delete" icon="pi pi-check" className='mr-3 p-button-raised' onClick={confirmDelete} />
        <Button label="Close" icon="pi pi-times" className="mr-3 p-button-secondary" onClick={() => setDeleteConfirmation(false)} />
      </Dialog >
      <Toast ref={toast} ></Toast>
      <Toast ref={toast2} ></Toast>

    </div>
  )

}
